import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type Row } from '@tanstack/react-table';
import { MessageCircle, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { type RecentPatientDTO } from 'types/appointments';
import { BookButton } from './BookButton';

interface PatientActionsProps {
  row: Row<RecentPatientDTO>;
}

export const PatientActions = ({ row }: PatientActionsProps): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.PSYCHOLOGIST);
  const patientId = row.original.id;

  const handleStartChat = (): void => {
    navigate(ROUTES.CHAT, {
      state: { patientId },
    });
  };

  const handleViewProfile = (): void => {
    navigate(ROUTES.PATIENT_PROFILE.replace(':id', patientId));
  };

  return (
    <div className="flex gap-2 max-am-sm:flex-col">
      <Button
        className="text-xs w-fit max-am-sm:w-full"
        variant="terciary"
        icon="leading"
        onClick={handleStartChat}
      >
        <MessageCircle size={8} />
        {t('PsychologistPatients.startChat.cta')}
      </Button>
      <Button
        variant="terciary"
        icon="leading"
        className="text-xs w-fit max-am-sm:w-full"
        onClick={handleViewProfile}
      >
        <User size={8} />
        {t('PsychologistPatients.viewProfile.cta')}
      </Button>
      <BookButton row={row} />
    </div>
  );
};
